var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3662.137)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3997.95,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3997.95,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3910.622,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.193,
    cy: 3828.063,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360.684 3280.58) scale(1.02274)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -205.976,
    cy: 485.489,
    r: 59.759,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -205.976,
    cy: 485.489,
    r: 45.07,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -205.976,
    cy: 485.489,
    r: 38.811,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-188.246-484.058a21.069 21.069 0 0 1-20.673 21.065 21.069 21.069 0 0 1-21.45-20.273 21.069 21.069 0 0 1 19.866-21.827 21.069 21.069 0 0 1 22.197 19.452",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.60038757,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.20077528,13.20077528",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -205.976,
    cy: 485.489,
    r: 7.853,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -205.976,
    cy: 485.489,
    r: 3.586,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 150.026,
    cy: 3777.107,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3910.622,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3910.622,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3910.622,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.166-3911.222a21.548 21.548 0 0 1-21.142 21.544 21.548 21.548 0 0 1-21.938-20.734 21.548 21.548 0 0 1 20.318-22.324 21.548 21.548 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3910.622,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3910.622,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.791,
    cy: 3726.107,
    r: 61.118,
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.791,
    cy: 3726.107,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.791,
    cy: 3726.107,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.661-3726.485a21.548 21.548 0 0 1-21.143 21.544 21.548 21.548 0 0 1-21.937-20.734A21.548 21.548 0 0 1 40.899-3748a21.548 21.548 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.791,
    cy: 3726.107,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.791,
    cy: 3726.107,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.026,
    cy: 3777.107,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.026,
    cy: 3777.107,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.542-3778.05a21.548 21.548 0 0 1-21.142 21.543 21.548 21.548 0 0 1-21.938-20.734 21.548 21.548 0 0 1 20.318-22.323 21.548 21.548 0 0 1 22.701 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.026,
    cy: 3777.107,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.026,
    cy: 3777.107,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.193,
    cy: 3828.063,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.193,
    cy: 3828.063,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.357-3829.572a21.548 21.548 0 0 1-21.143 21.544 21.548 21.548 0 0 1-21.937-20.734 21.548 21.548 0 0 1 20.317-22.323 21.548 21.548 0 0 1 22.702 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.193,
    cy: 3828.063,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.193,
    cy: 3828.063,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#000037",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3910.622,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3910.622,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.093-3911.904a21.548 21.548 0 0 1-21.142 21.544 21.548 21.548 0 0 1-21.938-20.734 21.548 21.548 0 0 1 20.318-22.324 21.548 21.548 0 0 1 22.701 19.895",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3910.622,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3910.622,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3997.95,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3997.95,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.564-3998.548a21.548 21.548 0 0 1-21.142 21.544 21.548 21.548 0 0 1-21.938-20.734 21.548 21.548 0 0 1 20.318-22.323 21.548 21.548 0 0 1 22.701 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3997.95,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.568,
    cy: 3997.95,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3997.95,
    r: 46.095,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3997.95,
    r: 39.693,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.492-3999.23a21.548 21.548 0 0 1-21.143 21.544 21.548 21.548 0 0 1-21.938-20.734 21.548 21.548 0 0 1 20.318-22.323 21.548 21.548 0 0 1 22.702 19.894",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 0.29670332,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 6.75044918,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "13.50089867,13.50089867",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "scale(1 -1) rotate(.395)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3997.95,
    r: 8.032,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.498,
    cy: 3997.95,
    r: 3.668,
    style: {
      opacity: 1,
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin7);
export default __webpack_public_path__ + "static/media/Pin7.29637007b83d1b0e0c1e09eb6cbb80e9.svg";
export { ForwardRef as ReactComponent };